import axios from 'axios'

const getAddressViaCep = cep =>
	axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(({ data }) => data)

export { getAddressViaCep }
